import React from 'react';

import { Field, FormikProps } from 'formik';

import { Select } from 'antd';

import { ListOption } from '@app/objects/SidebarProps';
import '@app/scss/components/customField.scss';
import '@app/scss/components/customSelect.scss';

interface CustomSelectProps {
	formikBag: FormikProps<any>;
	options: any;
	onChange: (value: string | number, option: any) => void;
	showSearch: boolean;
	name: string;
	placeholder?: string;
	onFocus?: () => void;
	onSelect?: any;
	onSearch?: (value: string) => void;
	transform?: boolean;
	parentContainer?: string;
	disabled?: boolean;
	annotation?: string;
	value?: string | number;
	showArrow?: boolean;
	open?: any;
	defaultValue?: string | number;
	prefixIcon?: React.ReactNode;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
	placeholder = 'Please make a selection',
	options,
	onSelect,
	onChange,
	showSearch,
	name,
	onSearch,
	onFocus,
	transform = false,
	formikBag,
	parentContainer,
	disabled = false,
	annotation,
	value,
	showArrow = true,
	defaultValue = undefined,
	open,
	prefixIcon,
}) => {
	const selectOptions = React.useMemo(() => {
		if (!transform || !Array.isArray(options)) {
			return options;
		}

		return options.map<ListOption>((item) => ({
			value: item.id ? item.id : item.name,
			label: item.name ? item.name : item.label,
		}));
	}, [options, transform]);

	const search = (value, showSearch, onSearch) => {
		if (showSearch && onSearch) {
			onSearch(value);
		}
	};

	const [isOpen, setIsOpen] = React.useState<boolean | undefined>(open !== undefined ? open : undefined);

	React.useEffect(() => {
		setIsOpen(open);
	}, [open]);

	return (
		<div
			className={!annotation ? 'search-field search-field_auto custom-select' : 'search-field search-field_auto custom-select with-annotation'}
		>
			<div className="search-field__annotation">{annotation}</div>
			<Field name={name}>
				{(field) => {
					return (
						<div
							className={
								field.form.errors[name] && field.form.touched[name]
									? !!field.form.values[name] && field.form.values[name] !== -1
										? 'custom-field filled error'
										: 'custom-field error'
									: !!field.form.values[name] && field.form.values[name] !== -1
										? 'custom-field filled'
										: 'custom-field'
							}
						>
							{prefixIcon && (
								typeof prefixIcon === 'string' ? (
									<div className="custom-input__prefix-icon">
										<img src={prefixIcon} alt="img" />
									</div>
								) : (
									<div className="custom-input__prefix-icon">
										{prefixIcon}
									</div>
								)
							)}
							<Select
								showSearch={showSearch}
								placeholder={placeholder}
								options={selectOptions}
								optionFilterProp="label"
								onSelect={onSelect}
								onChange={onChange}
								onSearch={(value: any) => search(value, showSearch, onSearch)}
								filterOption={() => showSearch}
								onFocus={() => {
									showArrow ? setIsOpen(undefined) : setIsOpen(false);

									if (onFocus) {
										onFocus();
									}
								}}
								className={!showArrow ? 'noShowArrow' : ''}
								popupClassName="custom-field-dropdown"
								onBlur={() => field.form.setFieldTouched(name, true)}
								open={isOpen}
								getPopupContainer={parentContainer ? () => document.querySelector(parentContainer)! : undefined}
								disabled={disabled}
								value={value}
								defaultValue={defaultValue}
								allowClear={!showArrow}
							/>
							<div className="custom-input__placeholder-top">{placeholder}</div>
							{field.form.errors[name] && field.form.touched[name] ? (
								<div className="custom-input__error">{field.form.errors[name]}</div>
							) : null}
						</div>
					);
				}}
			</Field>
		</div>
	);
};

export default CustomSelect;
